import { createFileRoute } from '@tanstack/react-router'
import { APP_NAME } from '@/lib/utils'
import FacturesClients from '@/features/factures-clients'

export const Route = createFileRoute('/_authenticated/factures-clients/')({
  component: FacturesClients,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Factures clients`,
      },
    ],
  }),
})
